import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Settings as SettingsIcon,
  Groups as GroupsIcon,
  AttachMoney as MoneyIcon,
  LocationOn as LocationIcon,
  EmojiEvents as TrophyIcon,
  Star as StarIcon,
  HelpOutline as HelpIcon,
  AdminPanelSettings as AdminIcon,
  Receipt as ReceiptIcon
} from '@mui/icons-material';
import './Settings.css';

const Settings: React.FC = () => {
  const navigate = useNavigate();

  const settingsCards = [
    {
      id: 'role-management',
      title: 'Role Management',
      description: 'Manage user roles and permissions across your organization.',
      icon: AdminIcon,
      route: '/role-management',
      color: 'blue'
    },
    {
      id: 'group-management',
      title: 'Group Management',
      description: 'Organize users into groups for better access control.',
      icon: GroupsIcon,
      route: '/groups',
      color: 'green'
    },
    {
      id: 'plans',
      title: 'Subscription Plans',
      description: 'Manage your subscription and billing preferences.',
      icon: MoneyIcon,
      route: '/plans',
      color: 'purple'
    },
    {
      id: 'geofencing',
      title: 'Geofencing',
      description: 'Configure location-based alerts and boundaries.',
      icon: LocationIcon,
      route: '/geofencing',
      color: 'orange'
    },
    {
      id: 'points-history',
      title: 'Points History',
      description: 'Track your reward points and transaction history.',
      icon: TrophyIcon,
      route: '/points-history',
      color: 'yellow'
    },
    {
      id: 'points-transfer',
      title: 'Points Transfer',
      description: 'Transfer points between users and accounts.',
      icon: StarIcon,
      route: '/points-transfer',
      color: 'pink'
    },
    {
      id: 'support',
      title: 'Support Tickets',
      description: 'Get help and submit support requests.',
      icon: HelpIcon,
      route: '/support-tickets',
      color: 'indigo'
    },
    {
      id: 'transaction-management',
      title: 'Transaction Management',
      description: 'View and manage payment transactions and orders.',
      icon: ReceiptIcon,
      route: '/transaction-management',
      color: 'teal'
    }
  ];

  return (
    <div className="settings-container">
      <div className="settings-content">
        {/* Professional Banner Header */}
        <div className="settings-header">
          <div className="header-banner">
            <div className="banner-content">
              <div className="banner-icon">
                <SettingsIcon className="icon" />
              </div>
              <div className="banner-text">
                <h1 className="banner-title">Settings</h1>
                <p className="banner-subtitle">Manage your account preferences and system configurations</p>
              </div>
            </div>
          </div>
        </div>

        {/* Settings Grid */}
        <div className="settings-section">
          <div className="section-header">
           
            <h2 className="section-title">System Preferences</h2>
          </div>

          <div className="settings-grid">
            {settingsCards.map((card) => (
              <div key={card.id} className="settings-card">
                <div className="card-content">
                  {/* Icon */}
                  <div className="card-icon-container">
                    <div className={`card-icon ${card.color}`}>
                      <card.icon className="icon" />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="card-text">
                    <h3 className="card-title">{card.title}</h3>
                    <p className="card-description">{card.description}</p>
                  </div>

                  {/* Action Button */}
                  <button
                    onClick={() => navigate(card.route)}
                    className="card-button"
                  >
                    <span>Access Settings</span>
                    <svg className="button-arrow" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings; 